import { gql } from '@apollo/client';

export const ALERT_BAR = gql`
  query getAlertBar($preview: Boolean) {
    alertBar(preview: $preview) {
      textAlignment
      backgroundColor
      customBackgroundColor
      newVisitorMessage {
        mobileCopy
        desktopCopy
        link
      }
      returningVisitorMessage {
        mobileCopy
        desktopCopy
        link
      }
    }
  }
`;

export default {};
